import { defineNuxtPlugin } from "#app";
import nuxtStorage from "nuxt-storage";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("nuxtStorage", nuxtStorage);
});
